import type { ReactNode } from 'react';
import { Grid } from '@/ui';

type Props = {
  children: ReactNode;
  monthKey?: string;
};

export const HeaderRow = ({ children, monthKey }: Props) => {
  return (
    <Grid
      data-measure={monthKey ? `header-row-${monthKey}` : undefined}
      templateColumns="repeat(7, minmax(0, 1fr))"
    >
      {children}
    </Grid>
  );
};
